import { standardGridPageSize, customAutoCompleteFilter } from "../../Shared/GlobalVariables/filterVariables";
import { halSchemaKendoGrid } from "../../Shared/kendo.module";

export default /*@ngInject*/ function ($scope, $rootScope, SavedReportSelectorService, objectIdDataService, CustomReportServices, $filter, reportsDataService, reportsService, helperService, snapshotsDataService, dataService) {

    const vm = this;

    $scope.$on('kendoWidgetCreated', function () {
        if (vm.grid) {
            vm.gridReady = true;
            runSavedReport();
        }
    });

    vm.helperService = helperService;

    vm.runSavedReport = runSavedReport;
    vm.populateCriteriaModel = populateCriteriaModel;
    vm.recordTypeSelectedChanged = recordTypeSelectedChanged;
    vm.getRecordType = getRecordType;
    vm.onReadGrid = onReadGrid;
    vm.onClearFilters = onClearFilters;
    vm.onApplyFilter = onApplyFilter;
    vm.deleteFilter = deleteFilter;
    vm.generateGridWithSelectedValues = generateGridWithSelectedValues;
    vm.open1 = open1;

    async function activate() {
        createCurrentSnapshotGrid();
        getRecordType();
        recordTypeSelectedChanged();
        await getObjectId();
        today();

        vm.dateCriteria = [
            {
                "DataType": "DateTime",
                "FieldName": "Date",
                "IsNullable": false
            }
        ];

        vm.dateOptions = {
            showWeeks: 'false',
            formatYear: 'yy',
            maxDate: new Date(),
            minDate: new Date(2000, 5, 22),
            startingDay: 1
        };

        vm.popup1 = {
            opened: false
        };

        getReportMetadata().then(_ => {
            vm.filterCriteria.fields = reportsService.getFields(vm.reportMetadata.Columns);
            if ($rootScope.loadedSavedReport) {
                runSavedReport();
            }
        });
    }

    activate();

    // --- FOR ADVANCED FILTERING ---
    vm.filterCriteria = {};
    vm.filterCriteria.query = [];
    // ---

    async function getObjectId() {
        let objectId = await objectIdDataService.getObjectID();
        let securityObject = helperService.getSecurityObjectDetailsFromObjectId(objectId);
        vm.ObjectId = objectId;
        vm.reportName = securityObject.Name;
        vm.reportId = securityObject.ReportID;
        vm.filtersDataSource = CustomReportServices.setfiltersDataSource(vm.ObjectId);
    }
    async function runSavedReport() {

        if (vm.gridReady && $rootScope.loadedSavedReport && vm.recordTypeDataSource && vm.recordDataSource && vm.filterCriteria.fields) {
            // --- FOR ADVANCED FILTERING ---
            vm.filterCriteria.query = reportsService.getSavedReportFilters();
            vm.filterCriteria.needsUpdate = true;
            // ---
            generateGridWithSelectedValues();
        } else if (vm.gridReady && !$rootScope.loadedSavedReport && vm.recordTypeDataSource && vm.recordDataSource && vm.filterCriteria.fields) {
            // We want the necessary report details available to be able to use the report toolbar without running the report
            populateCriteriaModel();
        }
    }

    function createCurrentSnapshotGrid() {

        vm.mainGridColumns = [
            { field: "RecordId", title: "Record Id", filterable: customAutoCompleteFilter },
            { field: "RecordName", title: "Record Name", filterable: customAutoCompleteFilter },
            { field: "Field", title: "Field", filterable: customAutoCompleteFilter },
            { field: "Value", title: "Value", filterable: customAutoCompleteFilter }
        ];

        vm.mainGridOptions = helperService.setMainGridOptions(null, 600);
        vm.mainGridOptions.autoBind = false;

        // Don't allow filtering and sorting yet because they will force the report to run
        if (!$rootScope.loadedSavedReport) {
            vm.mainGridOptions.sortable = false;

            vm.mainGridOptions.filterable = false;
        }

        vm.gridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            schema: halSchemaKendoGrid,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            transport: {
                read: async function (options) {
                    delete $rootScope.loadedSavedReport;
                    let data = { 'Date': vm.savedDate, 'RecordTypeId': vm.recordType, 'RecordId': vm.record };
                    vm.sortsAndFilters = helperService.prepareSortsAndFilters(options);
                    data['QueryInput'] = vm.sortsAndFilters;

                    // --- FOR ADVANCED FILTERING ---
                    if (vm.filterCriteria.query) {
                        data['QueryInput'].Filters = data['QueryInput'].Filters.concat(vm.filterCriteria.query);
                    }
                    // ---

                    // if tabs are on, save report info for the tab
                    if ($rootScope.tabs.length > 0) {
                        reportsService.saveTabReportInfo(vm);
                    }

                    let params = { 'pagesize': options.data.pageSize, 'page': options.data.page };

                    try {
                        let response = await snapshotsDataService.updateReportCurrentByDate(data, params);
                        data = response.data._embedded.reportData;
                        options.success(response.data);
                        vm.enableGrid = true;                     
                    } catch {
                        return;
                    }

                }
            }
        });

        setLayout(); 

    }


    async function getRecordType() {
        let response = await snapshotsDataService.getRecordType();
        response.data = $filter('filter')(response.data, { Enabled: true });
        response.data = $filter('orderBy')(response.data, 'DisplayName');
        vm.recordTypeDataSource = response.data;

        vm.selectedRecordType = SavedReportSelectorService.checkSavedReportForRecordType($rootScope.loadedSavedReport, response.data, vm.selectedRecordType);
        recordTypeSelectedChanged();
        runSavedReport();
    }

    async function recordTypeSelectedChanged() {
        try {
            if (vm.selectedRecordType) {
                let response = await snapshotsDataService.getDistinctRecordType(vm.selectedRecordType.Id);
                let allRecords = { "RecordName": "All Records", "RecordId": 'AllObjectsInMultiSelect' };
                response.data.unshift(allRecords);

                vm.recordDataSource = response.data;
                vm.selectedRecord = response.data[0];

                vm.selectedRecord = SavedReportSelectorService.checkSavedReportForRecord($rootScope.loadedSavedReport, response.data, vm.selectedRecord);
                populateCriteriaModel();
                runSavedReport();
            }
        } catch {
            return;
        }
    }



    //Date picker settings
    function today() {
        vm.dateSelected = new Date();
        vm.dateSelected = SavedReportSelectorService.checkSavedReportForDate($rootScope.loadedSavedReport, "Date", vm.dateSelected);
    }

    function open1() {
        vm.popup1.opened = true;
    }

    function populateCriteriaModel() {
        // do not continue if the proper criteria are not loaded
        if (!vm.dateSelected || vm.selectedRecordType === undefined || vm.selectedRecord === undefined) {
            return;
        }

        let criteria = [];

        vm.savedDate = vm.dateSelected;
        vm.recordType = vm.selectedRecordType.Id;
        if (vm.selectedRecord.RecordId === 'AllObjectsInMultiSelect') {
            vm.record = null;
        } else {
            vm.record = vm.selectedRecord.RecordId;
        }

        criteria.push(CustomReportServices.CreateCriteria("Date", 'Date', vm.savedDate, vm.savedDate));
        criteria.push(CustomReportServices.CreateCriteria("RecordTypeId", 'RecordType', vm.selectedRecordType.DisplayName, vm.selectedRecordType.Id));
        criteria.push(CustomReportServices.CreateCriteria("RecordId", 'Record', vm.selectedRecord.RecordName, vm.selectedRecord.RecordId));

        vm.reportDetailsModel = criteria;

        // if tabs are on, save report info for the tab
        if ($rootScope.tabs.length > 0) {
            reportsService.saveTabReportInfo(vm);
        }
    }

    function onApplyFilter(selectedFilter) {
        const currentOptions = vm.grid.getOptions();

        if (selectedFilter && selectedFilter.Filters && selectedFilter.Filters.length > 0) {
            currentOptions.dataSource.filter = helperService.convertFiltersForGrid(_, selectedFilter.Filters);
            try {
                vm.grid.dataSource._filter = currentOptions.dataSource.filter;
                vm.grid.dataSource.read();
            }
            catch (err) {
                vm.gridDataSource.filter({});
            }
        }
    }

    function onReadGrid() {
        vm.gridDataSource.read();
    }

    function onClearFilters() {
        vm.gridDataSource.filter({});
    }


    function generateGridWithSelectedValues() {

        if (!$rootScope.loadedSavedReport) {
            vm.grid.dataSource._filter = null;
            vm.grid.dataSource._sort = null;
        }

        populateCriteriaModel();
        vm.hideExportOptionsFromSubmit = true;

        // Add back the sorting and filtering options if we are running the report for the first time
        if (!$rootScope.loadedSavedReport) {
            vm.grid.setOptions({
                filterable: {
                    mode: "row"
                },
                sortable: true
            });
        }


        SavedReportSelectorService.queryGridWithOptions($rootScope.loadedSavedReport, vm.grid, true);
    }

    function deleteFilter(id) {
        CustomReportServices.deleteFilterFilterManager(vm, id);
    }
    function setLayout() {
        if (!$rootScope.loadedSavedReport) {
            CustomReportServices.loadSavedGridLayout(vm, null);
        }
    }

    // --- FOR ADVANCED FILTERING ---
    async function getReportMetadata() {
        let response = await reportsDataService.getReportMetadata(vm.reportId);
        vm.reportMetadata = response.data._embedded.reportData;
        vm.reportMetadata.Columns = $filter('orderBy')(vm.reportMetadata.Columns, 'DisplayName');
        vm.filterCriteria.fields = await reportsService.getFields(vm.reportMetadata.Columns);
        return vm.reportMetadata;
    }
    // ---
}